import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { WorkflowRun, WorkflowRunsFilter } from '../../types/generated.types';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';
import { DateHelper } from '../../helpers/date.helper';
import { DateRange } from '../../types/date-range.type';

@Injectable({ providedIn: 'root' })
export class WorkflowRunsApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/workflow-runs`;
  }

  async getDatesWithData(): Promise<DateRange[]> {
    const datesWithData = await this.get<DateRange[]>('dates-with-data');
    ApiConversionHelper.convertDates(datesWithData, ['start', 'end']);
    return datesWithData.map(x => new DateRange(DateHelper.startOfDay(x.start), DateHelper.endOfDay(x.end)));
  }

  async getWorkflowRuns(from: Date, to: Date, filter: WorkflowRunsFilter): Promise<WorkflowRun[]> {
    const result = await this.get<WorkflowRun[]>(`${DateHelper.formatApiDateTime(from)}/${DateHelper.formatApiDateTime(to)}`, filter);
    ApiConversionHelper.convertDates(result, ['added', 'started', 'ended']);
    return result;
  }

  async startWorkflowRun(workflowId: string, input?: Record<string, any>): Promise<string> {
    return await this.postWithResult<{ inputs?: Record<string, any> }, string>(`start/${workflowId}`, { inputs: input });
  }
}
